var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"full-image",attrs:{"before-close":_vm.close,"modal":true}},[_c('div',{staticClass:"mask"}),_c('div',{staticClass:"image-box"},[_c('img',{attrs:{"src":_vm.url}})]),_c('div',{staticClass:"close",on:{"click":_vm.close}},[_c('i',{staticClass:"el-icon-close"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }